import { createActions } from 'redux-actions';
import { select } from 'redux-saga/effects';
import { authTokenSelector } from '../../session';
import { getApiUser } from './get';

const actions = createActions({
  USER: {
    GET_CURRENT: undefined
  }
})

export function* getCurrentUser() {
  const authToken = yield select(authTokenSelector);
  yield* getApiUser(authToken);
}

const configuration = {
  name: 'getCurrent',
  action: actions,
  sagas: getCurrentUser,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getCurrent.js